import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export const ValidatorsMessages = {
  phoneInvalid: marker('Please enter a valid phone number')
};
